/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RevenueCalculatorConfigDto } from '../../models/revenue-calculator-config-dto';

export interface RevenueCalculatorConfigControllerFindByStoreId$Params {
  storeId: string;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function revenueCalculatorConfigControllerFindByStoreId(http: HttpClient, rootUrl: string, params: RevenueCalculatorConfigControllerFindByStoreId$Params, context?: HttpContext): Observable<StrictHttpResponse<RevenueCalculatorConfigDto>> {
  const rb = new RequestBuilder(rootUrl, revenueCalculatorConfigControllerFindByStoreId.PATH, 'get');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RevenueCalculatorConfigDto>;
    })
  );
}

revenueCalculatorConfigControllerFindByStoreId.PATH = '/api/v1/stores/{storeId}/revenue-calculator-config';
